import Axios from 'axios'
import type { AxiosRequestConfig } from 'axios'

function getCsrfToken(): string {
  const name = 'csrftoken'
  const cookies = document.cookie.split(';')
  for (const cookie of cookies) {
    const trimmed = cookie.trim()
    if (trimmed.startsWith(name + '=')) {
      return trimmed.substring(name.length + 1)
    }
  }
  return ''
}

export const AXIOS_INSTANCE = Axios.create({
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
})

AXIOS_INSTANCE.interceptors.request.use((config) => {
  const token = getCsrfToken()
  if (token && config.headers) {
    config.headers['X-CSRFToken'] = token
  }
  // When sending FormData, remove the default JSON Content-Type so axios
  // can set multipart/form-data with the correct boundary automatically.
  if (config.data instanceof FormData && config.headers) {
    delete config.headers['Content-Type']
  }
  return config
})

// Orval mutator function — every generated API call flows through this
export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  return AXIOS_INSTANCE({ ...config, ...options }).then(({ data }) => data)
}

export type ErrorType<Error> = import('axios').AxiosError<Error>
export type BodyType<BodyData> = BodyData
